/**
 * 点评类型
 */
enum CAPABILITY_TASK_TYPE {
    ALL = '0',
    TASK = '1',
    NO_TASK = '2',
}
enum SCORE_TYPE {
    LOW = 'low',
    EQUAL = 'equal',
    HIGH = 'high',
}
/**
 * @desc 数据类型
 */
enum DATA_TYPE {
    USER = 1,
    DEPARTMENT,
}
enum ChartType {
    RADAR = 1,
    INTERVAL,
}
interface IBasicData {
    id: string;
    type: DATA_TYPE;
}
interface IPracticeInfo {
    title: string;
    score: number;
    obj_type?: number;
    homework_num: number;
}
/**
 * 数据视图 信息
 */
interface IPracticeEvalViewInfo {
    title: string;
    score: number;
    homework_num: number;
    finish_homework_user_num: number;
    department_user_num: number;
    child_list: IPracticeInfo[];
}
/**
 * 练习评价数据
 */
interface IPracticeEvalCriteriaData {
    title: string;
    score: number;
    homework_num: number;
    department_user_num: number;
    finish_homework_user_num: number;
    child_list: IPracticeInfo[];
    total_practice_num?: number;
    practice_num?: number;
    chatbot_practice_num?: number;
    homework_practice_num?: number;
}
interface IPracticeEvalInfo {
    view_data: IPracticeEvalViewInfo[];
    criteria_data: IPracticeEvalCriteriaData[];
}
interface IPracticeBasicInfo {
    id: string;
    title: string;
    desc: string;
    obj_type?: number;
    disabled?: number; // 1: 不可点击
}
/**
 * 练习得分
 */
interface IPracticeScore {
    score: number;
    average_score: number;
    total_score: number;
}

/**
 * 维度数据
 */
interface IPracticeEvaluationDimensionInfoItem extends IPracticeBasicInfo {
    dimension_score: IPracticeScore;
    homework_num: number;
    total_practice_num?: number;
}
interface IPracticeEvaluationDimensionInfo {
    total: number;
    title_list?: string[];
    list: IPracticeEvaluationDimensionInfoItem[];
}
/**
 * 多维度视图数据
 */
interface IPracticeDataInfo extends IPracticeBasicInfo {
    homework_num: number;
    dimension_name?: string;
    aggregate_score: IPracticeScore;
    criteria_score: IPracticeScore;
    total_practice_num?: number;
    child_list?: IPracticeEvaluationDimensionInfo;
    evaluation_dimension_list: IPracticeEvaluationDimensionInfo;
}
/**
 * @desc 历史数据
 */
interface IPracticeHistoryResInfo {
    table_head: IPracticeBasicInfo[];
    list: IPracticeHistoryInfo[];
}

/**
 * @desc 历史数据
 */
export interface IPracticeHistoryDetailResInfo {
    table_head: IPracticeBasicInfo[];
    list: IPracticeHistoryDetailInfo[];
}

interface IPracticeHistoryInfoList {
    [key: string]: {
        [key: string]: IPracticeScore;
    };
}

/**
 * @desc 历史数据
 */
interface IPracticeHistoryInfo {
    date: number;
    date_format: string;
    list: IPracticeHistoryInfoList;
    aggregate_score: IPracticeScore;
}

/**
 * @desc 历史数据
 */
export interface IPracticeHistoryDetailInfo {
    date: number;
    date_format: string;
    aggregate_score: IPracticeScore;
    list: Record<string, IPracticeScore>;
}

export interface IPracticeHistoryDetailObjTypeInfo {
    date: number;
    date_format: string;
    aggregate_score: IPracticeScore;
    list: Record<string, Record<string, IPracticeScore>>;
}

/**
 * @desc 成员视图数据
 */
interface IPracticeDataMemberInfo {
    title: string;
    score: number;
    homework_num: number;
    total_user_num: number;
    get_score_user_num: number;
    dimension_list: IPracticeInfo[];
}
/**
 * @desc 数据视图信息
 */
interface IPracticeViewInfo {
    title: string;
    id: string;
}
/**
 * @desc 成员数据信息
 */
interface IMemberItemInfo {
    login_name: string;
    avatar: string;
    umu_id: string;
    date?: number;
    date_format: string;
    child_list?: Record<string, IPracticeScore>;
    aggregate_score: IPracticeScore;
}

interface IMemberItemObjTypeInfo {
    login_name: string;
    avatar: string;
    umu_id: string;
    date?: number;
    date_format: string;
    aggregate_score: IPracticeScore;
    child_list?: Record<string, Record<string, IPracticeScore>>;
}

interface IMemberDataInfo {
    page_info: IPageInfo;
    list: IMemberItemInfo[];
    table_head: IPracticeBasicInfo[];
}
interface IDataConfig {
    isAdmin: boolean;
}
export {
    DATA_TYPE,
    IDataConfig,
    IBasicData,
    SCORE_TYPE,
    ChartType,
    IPracticeEvalInfo,
    IPracticeHistoryResInfo,
    IPracticeViewInfo,
    IMemberItemInfo,
    IPracticeDataMemberInfo,
    IPracticeInfo,
    IMemberDataInfo,
    IPracticeScore,
    IPracticeBasicInfo,
    IPracticeHistoryInfo,
    IPracticeEvaluationDimensionInfoItem,
    IPracticeDataInfo,
    IPracticeEvalViewInfo,
    IPracticeEvaluationDimensionInfo,
    IPracticeEvalCriteriaData,
    CAPABILITY_TASK_TYPE,
    IMemberItemObjTypeInfo,
};
